import { useLocales } from '../../locales';
import * as PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { searchForPosts } from '../../redux/slices/analytics/postsList';

export function PostsFilter({ location, options, status }) {
  const [ordering, setOrdering] = useState(options[0].key);
  const handleOrdering = (ordering) => {
    setOrdering(ordering);
  };
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const { translate: t } = useLocales();
  const resetSearch = () => {
    setSearch('');
  };

  const handleSelect = (e) => {
    e.preventDefault();
    dispatch(searchForPosts(location, status, { ordering, search }));
  };

  const dispatchSearch = useCallback(() => {
    dispatch(searchForPosts(location, status, { search, ordering }));
  }, [dispatch, location, ordering, search, status]);

  useEffect(() => {
    const getData = setTimeout(() => {
      dispatchSearch();
    }, 200);

    return () => clearTimeout(getData);
  }, [dispatchSearch, search]);
  return (
    <div className="d-flex flex-end">
      <div className="d-flex align-items-center gap-2 gap-lg-3">
        <span className="px-5 fw-bolder d-md-none">
          <i className="fa-solid fa-magnifying-glass fs-1"></i>
        </span>
        <div className="ms-5 d-flex flex-row align-items-center form-horizontal d-none d-md-flex">
          {search ? (
            <div className="me-2">
              <a onClick={resetSearch} className="text-dark">
                <i className="far fa-times-circle cursor-pointer"></i>
              </a>
            </div>
          ) : (
            ''
          )}
          <div className="">
            <div>
              <div className="input-group">
                <input
                  type="text"
                  name="query"
                  className="form-control border-end-0 border textinput textInput"
                  placeholder="Search"
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                />
                <button
                  className="btn btn btn-outline btn-outline-secondary bg-white border-start-0 border ms-n5"
                  onClick={handleSelect}
                >
                  <i className="fa-solid fa-search fs-3"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center  d-none d-md-flex">
            <div className="mx-2">
              <div className="fa-solid fa-sort-amount-down"></div>
            </div>
          </div>
          <div className=" mb-0 input-group-xs">
            <select
              name="o"
              className="mb-0 input-group-xs csvselect form-select"
              onChange={(e) => handleOrdering(e.target.value)}
            >
              {options.map((item, i) => {
                return (
                  <option value={item.key} key={i}>{`${t(item.text)}, ${t(
                    item.desc
                  )}`}</option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

PostsFilter.propTypes = {
  location: PropTypes.string,
  options: PropTypes.array.isRequired,
  status: PropTypes.string
};
